import React from 'react'
import Skeleton from 'react-loading-skeleton'

const ShopSelectionBoxSkeleton = () => {
  return (
    <div className="d-flex" style={{ padding: '13px 16px 0 12px' }}>
      <Skeleton height={64} width={64} />
      <div className="d-flex flex-column" style={{ marginRight: 8 }}>
        <Skeleton width={130} height={17} style={{ marginBottom: 6 }} />
        <Skeleton width={130} height={17} style={{ marginBottom: 6 }} />
        <Skeleton width={300} height={17} />
      </div>
    </div>
  )
}

export default ShopSelectionBoxSkeleton
